import React from 'react'

const TeamsCart = ({position,nameOfMember, memberImg}) => {
  return (
    <div class="m-2  pb-1">
    <div class="group relative cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
        <div class="h-96 w-72">
          <img class="h-full w-full object-cover transition-transform duration-500 group-hover:rotate-3 group-hover:scale-125" src={memberImg} alt="" />
        </div>
        <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
        <div class="absolute inset-0  flex translate-y-[60%] flex-col items-center justify-center  text-center transition-all duration-500 group-hover:translate-y-0">
          <h3 class="font-serif text-3xl font-bold mt-[-50px] text-white">{nameOfMember}</h3>
          <p class="mb-3 text-lg italic text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">{position}</p>
        </div>
      </div>
    </div>
  
  )
}

export default TeamsCart
